<template>
  <div class="ExtraWorkManagement">
    <RequestManagementSpecificEWSearchPanel
      :accessTo="accessTo"
      @search="setSearchParams"
    />

    <box class="mt-2" :title="$t('specificExtraWorkList')">
      <div class="extraWorkList">
        <div v-if="list.length > 0">
          <specific-extra-work-management-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClickMission"
          />
          <specific-extra-work-management-list-mob
            @onClick="onClickMission"
            :list="list"
            class="hidden-md-and-up"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="d-flex px-4 py-2">
              <v-btn outlined color="primary" small @click="approveSelected">{{
                $t("approveSelected")
              }}</v-btn>
              <v-btn
                outlined
                color="primary"
                class="mx-2"
                small
                @click="returnSelected"
                >{{ $t("returnSelected") }}</v-btn
              >
            </div>
          </v-card-actions>
        </div>
        <!-- <div v-else>
          <EmptyList />
        </div> -->
      </div>
    </box>
    <specific-extra-work-management-details
      class="mt-2"
      ref="ExtraWorkManagementDetails"
      @refresh="search"
      @operationOnRequest="operationOnRequestDetails"
    />
  </div>
</template>

<script>
import RequestState from "@/model/RequestState";
import ResultType from "../../model/ResultType";
import AccessToType from "../../model/AccessToType";
import RequestManagementSpecificEWSearchPanel from "../../components/requestManagement/RequestManagementSpecificEWSearchPanel.vue";
import SpecificExtraWorkManagementListWeb from "../../components/requestManagement/specificextrawork/SpecificExtraWorkManagementListWeb.vue";
import SpecificExtraWorkManagementListMob from "../../components/requestManagement/specificextrawork/SpecificExtraWorkManagementListMob.vue";
import TextUtils from "../../utils/TextUtils";
import SpecificExtraWorkManagementDetails from "../../components/requestManagement/specificextrawork/SpecificExtraWorkManagementDetails.vue";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";
import PushNotificationHelper from '../../notification/PushNotificationHelper';

export default {
  components: {
    RequestManagementSpecificEWSearchPanel,
    SpecificExtraWorkManagementListWeb,
    SpecificExtraWorkManagementListMob,
    SpecificExtraWorkManagementDetails,
  },
  data() {
    return {
      accessTo: -1,
      list: [],
      searchParams: {},
    };
  },
  mounted(){
   
  },
  created() {
    this.accessTo = AccessToType.SpecificExtraWork;
    debugger
    //console.log(this.accessTo);
  },
  methods: {
    setSearchParams(params) {
      debugger;
      this.searchParams = params;
      this.search();
    },
    search() {
      ////console.log(params);
      debugger;
      var params = this.searchParams;
      this.list = [];
      this.$store
        .dispatch("GetSpecificEWListForAdmins", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === ResultType.success) {
            this.list = result.data;
            //this.getFilteredList(result.data);
          } else {
            this.list = [];
          }
        });
    },
    getFilteredList(list) {
      this.list = [];
      switch (this.searchParams.searchKind.toString()) {
        case "1":
          //result = " status <> 1  AND status <> 10 AND status <> 11 ";
          this.list = list.filter(
            (item) =>
              item.status.toString() !== "1" &&
              item.status.toString() !== "10" &&
              item.status.toString() !== "11"
          );
          break;
        case "2":
          //result = " status = 10 ";
          this.list = list.filter((item) => item.status.toString() === "10");
          break;
        case "3":
          //result = " status = 1 ";
          this.list = list.filter((item) => item.status.toString() === "1");
          break;
        case "4":
          //result = " status = 2 ";
          this.list = list.filter((item) => item.status.toString() === "2");
          break;
        case "7":
          //result = " status = 11 ";
          this.list = list.filter((item) => item.status.toString() === "11");
          break;
        case "5":
          //result = "1 = 1";
          this.list = list;
          break;
      }
    },
    onClickMission(item) {
      this.hideDetails();
      ////console.log(item);
      //this.$refs.ExtraWorkManagementDetails.show(item, item);
      const params = new URLSearchParams();
      params.append(
        "pageNo",
        TextUtils.convertToEnglishDigits(item.PAGENO.toString().trim())
      );
      params.append("dbkind", "1");
      params.append("year", item.Year);

      this.$store
        .dispatch("GetSpecificEwDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.Table.length > 0) {
              let details = result.data.Table[0];
              this.$refs.ExtraWorkManagementDetails.show(item, details);
            }
          }
        });
    },
    hideDetails() {
      this.$refs.ExtraWorkManagementDetails.hide();
    },
    async approveSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Approve;
      this.OprationOnRequest(requestState, selectedList);
    },
    returnSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Return;
      this.OprationOnRequest(requestState, selectedList);
    },
    operationOnRequestDetails(requestState, selectedList) {
      this.OprationOnRequest(requestState, selectedList);
    },
    async OprationOnRequest(requestState, selectedList) {
      //console.log(selectedList);
      var params = [];
      var adminPerno = this.$store.state.auth.auth.username;
debugger;
      if (EosUtils.isWebKartAdmin()) {
        //
        selectedList.forEach((item) => {
          var param = {
            PageNo: TextUtils.convertToEnglishDigits(
              item.PAGENO.toString().trim()
            ),
            Year: item.Year,
            adminPerno: adminPerno,
            perno: TextUtils.convertToEnglishDigits(
              item.perno.toString().trim()
            ),
            RequestState: requestState,
            ReasonOfAdmin: "webkart",
            Status: 10,
            IsSpecificEw: true,
          };
          params.push(param);
        });
        this.OprationOnExtraWorkRequest(params);
      } else {
        //
        let callback = function (resList) {
          //console.log(resList);
          resList.forEach((res, index) => {
            if (res.type === ResultType.success) {
              var s = res.data;
              //console.log(s, index);
              var item = selectedList[index];
              var param = {
                PageNo: TextUtils.convertToEnglishDigits(
                  item.PAGENO.toString().trim()
                ),
                Year: item.Year,
                adminPerno: adminPerno,
                perno: TextUtils.convertToEnglishDigits(
                  item.perno.toString().trim()
                ),
                RequestState: requestState,
                ReasonOfAdmin: "webkart",
                Status: s,
                IsSpecificEw: true,
              };
              params.push(param);
            }
          });
        };
        if (selectedList.length > 0) {
          await this.GetApproveDegree(selectedList, callback).then(() => {
            this.OprationOnExtraWorkRequest(params);
          });
        }
      }
    },
    async GetApproveDegree(list, callback) {
      let promises = [];
      list.forEach((item) => {
        //console.log(item);
        var approveParams = {
          perno: TextUtils.convertToEnglishDigits(item.perno.toString().trim()),
          section: TextUtils.convertToEnglishDigits(
            item.section.toString().trim()
          ),
          status: TextUtils.convertToEnglishDigits(
            item.status.toString().trim()
          ),
          isSpecificEw: true,
        };

        promises.push(
          this.$store.dispatch("GetExtraWorkApproveDegree", { approveParams })
        );
      });

      await Promise.all(promises)
        .then(callback)
        .catch((err) => {
          console.log(err);
        });
    },
    OprationOnExtraWorkRequest(params) {
      //console.log(params);
      this.$store
        .dispatch("OprationOnExtraWorkRequest", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.search();
            if (result.data && result.data.length > 0) {
              var description = result.data[0].Description;
              this.$EosToast.show({
                type: EosToastType.success,
                msg: description,
              });
              //this.$refs.snackbar.show("success", description);
              params.forEach((param) => {
                PushNotificationHelper.sendNotification(
                  param.adminPerno,
                  param.perno,
                  param.RequestState,
                  param.RequestState
                );
              });
            }
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error,
            });
            //this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style>
</style>
